import { render, staticRenderFns } from "./ScormReport.vue?vue&type=template&id=7bb1b0d6&scoped=true"
import script from "./ScormReport.vue?vue&type=script&lang=js"
export * from "./ScormReport.vue?vue&type=script&lang=js"
import style0 from "./ScormReport.vue?vue&type=style&index=0&id=7bb1b0d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb1b0d6",
  null
  
)

export default component.exports